import * as z from 'zod';

const createEnv = () => {
  const EnvSchema = z.object({
    NODE_ENV: z.enum(['development', 'production']),
    API_URL: z.string(),
    GOOGLE_RECAPTCHA_KEY: z.string().optional(),
    ENABLE_API_MOCKING: z
      .string()
      .refine(s => s === 'true' || s === 'false')
      .transform(s => s === 'true')
      .optional(),
    APP_URL: z.string().optional().default('http://localhost:3000'),
    OLD_APP_URL: z.string().optional().default('https://app.bhanzu.com'),
    WS_SERVER_URL: z.string().optional().default('wss://ws.bhanzu.com'),
    APP_MOCK_API_PORT: z.string().optional().default('8080'),
    IS_OFFLINE: z
      .string()
      .refine(s => s === 'true' || s === 'false')
      .transform(s => s === 'true')
      .optional()
      .default('false'),
    WEBSITE_URL: z.string().optional().default('https://bhanzu.com'),
    GA_MEASUREMENT_ID: z.string(),
  });

  const envVars: Record<string, string> = {};
  for (const [key, value] of Object.entries(import.meta.env)) {
    if (key.startsWith('VITE_APP_')) {
      envVars[key.replace('VITE_APP_', '')] = String(value);
    }
  }

  const parsedEnv = EnvSchema.safeParse(envVars);

  if (!parsedEnv.success) {
    throw new Error(
      `Invalid env provided.
      The following variables are missing or invalid:
      ${Object.entries(parsedEnv.error.flatten().fieldErrors)
        .map(([k, v]) => `- ${k}: ${v.join(', ')}`)
        .join('\n')}
      `
    );
  }

  return parsedEnv.data;
};

export const env = createEnv();
